
import { NavLink } from 'react-router';

import styles from './button.module.css';

export function Button({

  children,
  variant,
  width,
  fontWeight = '',
  behaviour = 'button',
  link = '/',
  ...props
}) {
  if (behaviour === 'link') {
    return (
      <NavLink
        className={`${styles.button} ${styles[variant]} ${styles[width]} ${styles[fontWeight]} `}
        to={link}
      >
        {children}
      </NavLink>
    );
  }

  return (
    <button
      {...props}
      className={`${styles.button} ${styles[variant]} ${styles[width]} ${styles[fontWeight]} `}
    >
      {children}
    </button>
  );
}
